<template>
    <b-pagination
        v-if="meta && meta.total > meta.per_page"
        size="sm"
        :value="meta.current_page"
        :per-page="meta.per_page"
        :total-rows="meta.total"
        :align="align"
        v-on="$listeners"
    />
</template>

<script>
export default {
    name: "AppPagination",
    props: {
        meta: {
            type: Object | null,
            required: true,
        },
        align: {
            type: String,
            default: "fill",
        },
    },
};
</script>
